import moment from 'moment';
import { paymentPlansApi } from './api';
import { select } from '../shared/utils/dom';
import { delimiters } from '../shared/constants';
import formMixin from '../shared/vue/mixins/form';
import loadingMixin from '../shared/vue/mixins/loading';
import { formatBasicCurrency } from '../shared/utils/misc';

/**
 * Enrolling in auto pay
 */
export default function paymentPlanDetails() {
  const el = select('[data-vue-app="payment-plan-details"]');

  if (el) {
    const app = new Vue({ // eslint-disable-line no-unused-vars
      el,
      delimiters,
      mixins: [formMixin, loadingMixin],
      data: {
        isReady: false,
        // plan details
        accountNumber: '',
        currentAmountBilled: '',
        totalAmountDue: '',
        enrollmentStatusType: '',
        enrollmentPlanType: '',
        initialPaymentAmount: '',
        initialPaymentDueDate: '',
        monthlyPayment: '',
        nextPaymentDate: '',
        planLdcType: '',
        termPeriodMonths: '',
      },
      mounted() {
        this.loading = true;
        Vue.nextTick(() => {
          // get the plan details
          this.getPaymentPlanDetails();
        });
      },
      /**
       * Methods
       */
      methods: {
        // get the plan details from the API
        getPaymentPlanDetails() {
          paymentPlansApi.getPaymentPlanStatus()
            .then((response) => {
              this.accountNumber = response.data.accountId;
              this.currentAmountBilled = response.data.currentAmountBilled ? response.data.currentAmountBilled : '';
              this.totalAmountDue = formatBasicCurrency(response.data.currentBalance);
              this.enrollmentStatusType = response.data.enrollmentStatusType;
              this.enrollmentPlanType = response.data.enrollmentType;
              this.initialPaymentAmount = response.data.initialPaymentAmount ? formatBasicCurrency(response.data.initialPaymentAmount) : '';
              this.initialPaymentDueDate = moment(response.data.initialPaymentDueDate).format('MMM DD, YYYY');
              this.monthlyPayment = response.data.nextPaymentAmount ? formatBasicCurrency(response.data.nextPaymentAmount) : '';
              this.nextPaymentDate = moment(response.data.nextPaymentDate).format('MMM DD, YYYY');
              this.planLdcType = response.data.planId === 'LV' || response.data.planId === 'SD' ? 'CIS' : 'DIS';
              this.termPeriodMonths = response.data.termPeriodMonths ? response.data.termPeriodMonths : '';
              this.loading = false;
              // app is ready when the details are there
              this.isReady = true;
            });
        },
      },
    });
  }
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/paymentPlanDetails.js